<template>
  <div>
    <div style="cursor: pointer;margin-bottom: 16px;color: #fff;" @click="back">
      <a-icon type="left" style="margin-right: 2px" />
      <span>返回</span>
    </div>
    <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }" :colon="false" @submit="handleSubmit">
      <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <SelectField style="width: 90%; margin: 0.5rem auto" label="所属分类" id="subType"
                         :modelValue="form.subType" :options="wellTypes" required
                         labelWidth="40%"  :disabled = "view === '修改截流井'"
                         @update:modelValue="(value) => handleModelValueUpdate('subType', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="编号" type="text" id="code"
                        :modelValue="form.code" placeholder="请输入编号" required
                        @update:modelValue="(value) => handleModelValueUpdate('code', value)"
            />
        </a-col>

      </a-row>
        <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="名称" type="text" id="name"
                        :modelValue="form.name" placeholder="请输入名称" required input-width="100%"
                        @update:modelValue="(value) => handleModelValueUpdate('name', value)"
            />
        </a-col>


        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="经纬度" type="text" id="lnglat"
                        :modelValue="form.lnglat" placeholder="请输入经纬度" inputImg required
                        @img-click="pasteLnglat"  :disabled = "view === '修改截流井'"
                        @update:modelValue="(value) => handleModelValueUpdate('lnglat', value)"
            />
        </a-col>

        </a-row>
        <a-row>
        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="唯一标识" type="text" id="sn"
                        :modelValue="form.sn" placeholder="请输入唯一标识" required
                        @update:modelValue="(value) => handleModelValueUpdate('sn', value)"
            />
        </a-col>

        <a-col :lg="12" :md="12" :sm="24">
            <InputField style="width: 90%; margin: 0.5rem auto" label="所属位置" type="text" id="location"
                        :modelValue="form.location" placeholder="请输入位置" required
                        @update:modelValue="(value) => handleModelValueUpdate('location', value)"
            />
        </a-col>
        <a-col :lg="12" :md="12" :sm="24">
            <SelectField style="width: 90%; margin: 0.5rem auto" label="设备状态" id="status"
                         :modelValue="form.status" :options="status" required labelWidth="40%"
                         @update:modelValue="(value) => handleModelValueUpdate('status', value)"
            />
        </a-col>


        <a-col :lg="24" :md="24" :sm="24">
            <div style="width: 95%;margin: auto;">
                <div style="color: #93a2b7;margin-bottom: 1rem;"><span style="visibility: hidden;">*</span>关联管道</div>
                <PipeTable
                        :category="form.category"
                        :list="pipeList"
                        :disabled="view === '修改截流井'"
                        @change="payload => pipeList = payload"
                />
            </div>
        </a-col>

      </a-row>

      <div class="center" style="margin-top: 1rem;">
        <a-space>
            <ButtonField text="取消" @click="back" secondary />
            <ButtonField text="保存" primary @click="handleSubmit"/>
        </a-space>
      </div>
    </a-form>
  </div>
</template>
<script>
import PipeTable from "../components/pipe-table";
import { mapGetters, } from "vuex";
import { add, edit, fetchDetail } from "@/api/assets/interceptWell.js";
import store from "../mixins/store";
import SelectField from "@/components/water-affairs-style/field/SelectField.vue";
import InputField from "@/components/water-affairs-style/field/InputField.vue";
import ButtonField from "@/components/water-affairs-style/field/ButtonField.vue";

export default {
  mixins: [store],
  components: {
      InputField,SelectField,ButtonField,PipeTable
  },
  data() {
    return {
      form: {
          subType:null,
          code:null,
          name:null,
          lnglat:null,
          sn:null,
          location:null,
          status:0,
      },
      detail: {},
      pipeList: [],
      saveLoading: false,
      // view:'修改截流井'
    };
  },

  watch: {
    selectedWell: {
      handler() {
        if (this.view === "修改截流井" && this.selectedWell._edit) {
          this.getDetail();
        }
      },
      deep: true,
    },
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    wellTypes() {
      return this.findDataDict("cutoffWellType");
    },
    status() {
      return this.findDataDict("status").map((item) => {
        return {
          value: parseInt(item.value),
          name: item.name,
        };
      });
    },
  },

  mounted() {
    if (this.view === "修改截流井" && this.selectedWell._edit) {
      this.getDetail();
    }
  },

  methods: {
    handleModelValueUpdate(fieldName, value) {
        this.form[fieldName] = value;
    },
    pasteLnglat() {
      const { lng, lat } = this.selectedLnglat;
      if (!lng) {
        this.$message.error("请点击地图选择经纬度");
        return;
      }
      this.form.setFieldsValue({
        lnglat: lng + "," + lat,
      });
    },


    getDetail() {
      this.detail = {};
      this.form = {
          subType:null,
          code:null,
          name:null,
          lnglat:null,
          sn:null,
          location:null,
          status:null,
      };
      this.pipeList = [];
      fetchDetail({ id: this.selectedWell.id, category: this.selectedWell.category }).then((res) => {
        if (!res.id) return;

        this.detail = res;

        this.form.code = res.code;
        this.form.subType = res.subType;
        this.form.name = res.name;
        this.form.location = res.location;
        this.form.sn = res.sn;
        this.form.status = res.status;
        this.form.lnglat = res.x + ',' + res.y;
          console.log(" this.form:::", this.form)
        // 井与管道关联
        if (!res.pipesFrom) {
          res.pipesFrom = [];
        }
        if (!res.pipesTo) {
          res.pipesTo = [];
        }

        this.pipeList = [
          ...res.pipesFrom.map((item) => {
            return {
              ...item,
              location: "from",
              code: item.code,
              category: item.category,
            };
          }),
          ...res.pipesTo.map((item) => {
            return {
              ...item,
              location: "to",
              code: item.code,
              category: item.category,
            };
          }),
        ];
      });
    },



    handleSubmit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      if (!this.form.subType) {
          this.$message.error('所属分类不能为空');
          this.isSubmitting = false;
          return;
      }
      if (!this.form.code) {
          this.$message.error('编号不能为空');
          this.isSubmitting = false;
          return;
      }
      if (!this.form.name) {
          this.$message.error('名称不能为空');
          this.isSubmitting = false;
          return;
      }
      if (!this.form.lnglat) {
          this.$message.error('经纬度不能为空');
          this.isSubmitting = false;
          return;
      }
      if (!this.form.sn) {
          this.$message.error('唯一标识不能为空');
          this.isSubmitting = false;
          return;
      }
      if (!this.form.location) {
          this.$message.error('所属位置不能为空');
          this.isSubmitting = false;
          return;
      }
      if (!this.form.status) {
          this.$message.error('设备状态不能为空');
          this.isSubmitting = false;
          return;
      }

      const arr = this.form.lnglat.split(",");
      const x = parseFloat(arr[0]);
      const y = parseFloat(arr[1]);

      let flag = false;
      if (this.pipeList.length > 0) {
          this.pipeList.forEach((item) => {
              if (!item.location) {
                  flag = true;
              }
          });
      }

      if (flag) {
          this.$message.error("请选择管线位置");
          return;
      }

      let params = {
          id: this.detail.id,
          ...this.form,
          type: "cutoffWell",
          x,
          y,
          pipePolicies: this.pipeList,
      };

      let task = add;
      if (this.detail.id) {
          task = edit;
      }


      task(params).then(() => {
          this.getFacilityList();
          this.back();
      }).finally(() => {
          this.isSubmitting = false;
      })
    },

    back() {
      this.detail = {};
      this.form = {
          subType:null,
          code:null,
          name:null,
          lnglat:null,
          sn:null,
          location:null,
          status:null,
      };
      this.pipeList = [];

      this.setSelectedLnglat({});
      this.setSelectedWell({});
      this.setSelectedPipe({});
      this.setView("截流井");
    },

  },

};
</script>

<style lang="less" scoped>
.location {
  display: block;
  height: auto;
  width: 12px;
}

.center {
  padding-bottom: 24px;
}
</style>
